import config from 'config';
import utils from 'utils';

const baseUrl = config.api[window.location.hostname].baseUrl;
const staticsBaseUrl = 'https://statics.getnofilter.com';

const getAll = () => {
  return fetch(`${baseUrl}/mod/spots`, {
    method: 'GET',
    headers: {
      Authorization: window.user.token,
      ...utils.getHeaders(),
    },
  }).then(utils.fetch.process);
};

const getAllLight = () => {
  return fetch(`${baseUrl}/mod/spots/get-all-light`, {
    method: 'GET',
    headers: {
      Authorization: window.user.token,
      ...utils.getHeaders(),
    },
  }).then(utils.fetch.process);
};

const getAllSlugs = () => {
  return fetch(`${baseUrl}/mod/spots/get-all-slugs`, {
    method: 'GET',
    headers: {
      Authorization: window.user.token,
      ...utils.getHeaders(),
    },
  }).then(utils.fetch.process);
};

const getAllSlugsFromSpotsV19 = () => {
  return fetch(`${staticsBaseUrl}/spots/spots-v19.json?cacheTimestamp=${Date.now()}`, {
    method: 'GET',
  }).then(utils.fetch.process);
};

// Everything spots-v19.json holds, including the moment it was built. The whole
// catalogue is 1.7 MB gzipped off the CDN, against a get-all-light that reads
// the entire spots collection out of Firestore to answer.
const getSpotsV19 = () => {
  return fetch(`${staticsBaseUrl}/spots/spots-v19.json?cacheTimestamp=${Date.now()}`, {
    method: 'GET',
  }).then(utils.fetch.process);
};

// Written next to spots-v19.json by the same build: the spots that still need a
// description, the ones missing translations, and the ones with no main photo.
const getDescriptionTodo = () => {
  return fetch(`${staticsBaseUrl}/spots/description-todo.json?cacheTimestamp=${Date.now()}`, {
    method: 'GET',
  }).then(utils.fetch.process);
};

const getCreatedSince = since => {
  return fetch(`${baseUrl}/mod/spots/created-since/${since}`, {
    method: 'GET',
    headers: {
      Authorization: window.user.token,
      ...utils.getHeaders(),
    },
  }).then(utils.fetch.process);
};

const getHydratedById = spotId => {
  return fetch(`${baseUrl}/mod/spots/get-hydrated-by-id`, {
    method: 'POST',
    headers: {
      Authorization: window.user.token,
      ...utils.getHeaders(),
    },
    body: JSON.stringify({ spotId }),
  }).then(utils.fetch.process);
};

const create = (spot, { suggestionId, ownerPoint } = {}) => {
  return fetch(`${baseUrl}/mod/spots/create`, {
    method: 'POST',
    headers: {
      Authorization: window.user.token,
      ...utils.getHeaders(),
    },
    body: JSON.stringify({
      spot,
      ...(suggestionId ? { suggestionId } : {}),
      // The create endpoint records the suggestion review itself, and that
      // review is where the spot is checked against the proposal.
      ...(ownerPoint ? { ownerPoint } : {}),
    }),
  }).then(utils.fetch.process);
};

const edit = (spot, newData) => {
  return fetch(`${baseUrl}/mod/spots/edit`, {
    method: 'POST',
    headers: {
      Authorization: window.user.token,
      ...utils.getHeaders(),
    },
    body: JSON.stringify({ spot, newData }),
  }).then(utils.fetch.process);
};

const assign = (spot, photo, { suggestionId } = {}) => {
  return fetch(`${baseUrl}/mod/spots/assign`, {
    method: 'POST',
    headers: {
      Authorization: window.user.token,
      ...utils.getHeaders(),
    },
    body: JSON.stringify({ spot, photo, ...(suggestionId ? { suggestionId } : {}) }),
  }).then(utils.fetch.process);
};

const translateDescriptionById = (spotId) => {
  return fetch(`${baseUrl}/mod/spots/translate-description-by-id`, {
    method: 'POST',
    headers: {
      Authorization: window.user.token,
      ...utils.getHeaders(),
    },
    body: JSON.stringify({ spotId }),
  }).then(utils.fetch.process);
};

const apiSpots = {
  getAll,
  getAllLight,
  getAllSlugs,
  getAllSlugsFromSpotsV19,
  getSpotsV19,
  getDescriptionTodo,
  getCreatedSince,
  getHydratedById,
  create,
  edit,
  assign,
  translateDescriptionById,
};

export default apiSpots;
